import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  Currency,
  CurrencySymbol,
  resolveFormattingLocale,
} from '@wilson/localization';

@Pipe({
  name: 'localizedNumber',
  pure: false, // Required to reload the pipe when the language changes
})
export class LocalizedNumberPipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  transform(
    value: string | number,
    pipeType: 'currency' | 'decimal',
    currency?: Currency,
  ): string | number | null {
    if (
      value == null ||
      isNaN(Number(value)) ||
      (pipeType !== 'currency' && pipeType !== 'decimal') ||
      (pipeType === 'currency' &&
        !Object.keys(Currency).includes(currency as Currency))
    ) {
      return value;
    }

    const locale = resolveFormattingLocale(
      this.translateService.getCurrentLang(),
    );
    const digitsInfo = '1.2-2';

    if (pipeType === 'decimal') {
      return new DecimalPipe(locale).transform(value, digitsInfo);
    }

    if (pipeType === 'currency') {
      return new CurrencyPipe(locale).transform(
        value,
        currency,
        CurrencySymbol[currency as Currency] ?? 'symbol-narrow',
        digitsInfo,
      );
    }

    return value;
  }
}
